export default __webpack_public_path__ + "static/media/NND.cfd8a365.svg";